import Vue from 'vue'
import { ModalPlugin } from 'bootstrap-vue'
import VTooltip from 'v-tooltip'
import VueGtag from "vue-gtag";
import { defaults } from "lodash";
import { iAPP_SETTINGS } from "@/types"
import { auth, db } from '@/firebase';
import * as config from "./config/config";
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import { logger } from "@/app/utils";
const SubHeader = () => import(/* webpackChunkName: "apputils" */ "@/components/SubHeader.vue"); 
const FirebaseTimestamp = () => import(/* webpackChunkName: "apputils" */ "@/components/FirebaseTimestamp.vue");

Vue.config.productionTip = false;
Vue.use(ModalPlugin);
Vue.use(VTooltip);
Vue.use(VueGtag, {
  config: { id: config.firebase_config.measurementId },
  appName: config.firebase_config.projectId
}, router);

Vue.component('sub-header', SubHeader);
Vue.component('firebase-timestamp',FirebaseTimestamp);

logger.info(`Firebase is loading from firebase project ${process.env.VUE_APP_FIREBASE_projectId}`);

auth.onAuthStateChanged((user: any) => {
  const currentUser = auth.currentUser;
  if (currentUser) {
    currentUser.getIdTokenResult().then(idtoken => {
      if (idtoken && idtoken.claims) {
        user.admin = idtoken.claims.admin;
        user.moderator = idtoken.claims.moderator;
        user.verifiedvolunteer = idtoken.claims.verifiedvolunteer;
        user.registeredvolunteer = idtoken.claims.registeredvolunteer;
      }
      store.dispatch("fetchUser", user);
    });
  } else {
    store.dispatch("fetchUser", user);
  }
});

const updateStorewithInitialSettings = ((appsettings: iAPP_SETTINGS) => {
  store.dispatch("updateApplicationSettings", defaults(appsettings, config.initial_app_settings));
});

const getInitialApplicationSettings = () => {
  return new Promise((resolve, reject) => {
    db
      .collection("application_settings")
      .doc("application_settings")
      .get()
      .then((docRef) => {
        const appsettings: any = docRef.data();
        if (appsettings) {
          updateStorewithInitialSettings(appsettings);
        } else {
          updateStorewithInitialSettings(config.initial_app_settings);
        }
        resolve(appsettings);
      }).catch((ex) => {
        updateStorewithInitialSettings(config.initial_app_settings);
        logger.log(ex);
        reject();
      })
  })
};

router.beforeEach(async (to, from, next) => {
  const user: any = store && store.state && store.state.user && store.state.user.loggedIn ? store.state.user.data : null;
  const isadmin = user && user.admin;
  const ismoderator = user && user.moderator;
  const isverifiedvolunteer = user && user.verifiedvolunteer;
  if(to.meta.authorized_users){
    if(to.meta.authorized_users.indexOf("loggedinuser")>-1 ){
      if (user) { 
        next(); 
      } else {  
        next('signout') 
      }
    } else if(to.meta.authorized_users.indexOf("verifiedvolunteer")>-1 ){
      if (isverifiedvolunteer || ismoderator || isadmin) { 
        next(); 
      } else {  
        next('signout') 
      }
    } else if(to.meta.authorized_users.indexOf("moderator")>-1 ){
      if (ismoderator || isadmin) { 
        next(); 
      } else {  
        next('signout') 
      }
    } else if(to.meta.authorized_users.indexOf("admin")>-1 ){
      if (isadmin) { 
        next(); 
      } else {  
        next('signout') 
      }
    } else {
      next();
    }
  } else {
    next();
  }
})

const start = () => {
  getInitialApplicationSettings().then(() => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }).catch(ex => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
    logger.log(ex);
  });
}
start();